<template>
  <div v-if="isShow.isKVShow" class="pg-kv">
    <div class="logo"></div>
    <div class="title-wp">
      <div class="title1 transLeft"></div>
      <div class="title2 transTop"></div>
    </div>
    <div class="pg-poem-wp">
      <p class="show show1">春城无处不飞花</p>
      <p class="show show2">寒食东风御柳斜</p>
      <span class="show show3">--韩愈</span>
    </div>
    <div class="bird-wp tran1">
      <div class="bird tran2"></div>
    </div>
    <div class="pg-btn scaleIt" @click="showNext"></div>
  </div>
</template>

<script>
export default {
  name: 'PageKV',
  props: {
    isShow: Object
  },
  data() {
    return {
    }
  },
  components: {
  },
  methods: {
    showNext () {
      setTimeout(() => {
        this.$emit('nextPage', 'isPOShow');
      }, 200);
    }
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg-kv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .bg('./img/kv-bg.jpg');
}
.logo {
  position: absolute;
  left: 50%;
  top: 2vh;
  margin-left: -4.5/4rem /* 72/16 */;
  width: 4.5/2rem /* 72/16 */;
  height: 2.9375/2rem /* 47/16 */;
  .bg('./img/logo.png');
}
.title-wp {
  position: absolute;
  top: 3.75rem /* 60/16 */;
  left: 50%;
  margin-left: -35.0625/4rem /* 561/16 */;
  width: 35.0625/2rem /* 561/16 */;
  height: 21.25/2rem /* 340/16 */;
  .bg('./img/kv-title-box.png');
  .title1 {
    position: absolute;
    top: 3rem;
    left: 2rem;
    width: 4.375/2rem /* 70/16 */;
    height: 8.9375/2rem /* 143/16 */;
    .bg('./img/kv-title1.png');
  }
  .title2 {
    position: absolute;
    right: 1.8rem;
    top: 1.8rem;
    width: 20.9375/2rem /* 335/16 */;
    height: 11.3125/2rem /* 181/16 */;
    .bg('./img/kv-title2.png');
  }
}
.pg-btn {
  position: absolute;
  left: 50%;
  bottom: 20vh;
  margin-left: -20/4rem /* 320/16 */;
  width: 20/2rem /* 320/16 */;
  height: 6.25/2rem /* 100/16 */;
  .bg('./img/kv-btn.png');
  transition: all .3s;
  &:active {
    transform: scale(.98);
    opacity: .6;
  }
}
.pg-poem-wp {
  position: absolute;
  min-width: 9.375rem /* 150/16 */;
  left: 50%;
  bottom: 40vh;
  color: #ffffff;
  text-shadow: 1px 1px 10px #fff;
  font-family: font-kt;
  letter-spacing: 4px;
  line-height: 1.6;
  p {
    text-align: right;
  }
  span {
    display: block;
    text-align: right;
  }
}
.start {
  position: relative;
  left: 50%;
  top: 30px;
  margin-left: -34px;
  padding: 8px 14px;
  outline: none;
  border: none;
  background-color: transparent;
  border: 1px solid grey;
  border-radius: 4px;
  color: grey;
  &:active {
    opacity: .6;
  }
}
.bird-wp {
  position: absolute;
  top: 30vh;
}
.bird {
  width: 2.375/2rem /* 38/16 */;
  height: 2.1875/2rem /* 35/16 */;
  .bg('./img/kv-bird.png');
}
.tran1 {
  animation: tran1 6s linear both infinite;
}
.tran2 {
  animation: tran2 6s cubic-bezier(.55,-0.48,.38,1.58) both infinite;
}
@keyframes tran1 {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(200vw);
  }
}
@keyframes tran2 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20vh);
  }
}
.transTop {
  animation: transTop 1s ease-in .5s both;
}
@keyframes transTop {
  from {
    opacity: 0;
    transform: translateY(50%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.transLeft {
  animation: transLeft 1s ease-in both;
}
@keyframes transLeft {
  from {
    opacity: 0;
    transform: translateX(-50%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.show {
  animation: show 1s ease-in both;
}
.show1 {
  animation-delay: 1s;
}
.show2 {
  animation-delay: 2s;
}
.show3 {
  animation-delay: 3s;
}
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.scaleIt {
  animation: scaleIt 1.8s ease-in-out 3s infinite both;
}
@keyframes scaleIt {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(.92);
  }
}
</style>
